export enum ERefundType {
  ORDER = 'ORDER', // full refund
  ORDER_PRODUCT = 'ORDER_PRODUCT', // partial refund
}
